import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';

export const StyledIssueRow = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem;
  color: ${getColor('shuttleGray')};
  & .issue-fte {
    font-weight: bold;
    margin-right: 0.5rem;
  }
  & .issue-key {
    margin-right: 0.5rem;
  }
`;

export const StyledIssuesList = styled.div`
  padding: 1rem;
  border: 1px solid ${getColor('catskillWhite')};
  width: 100%;
  height: 100%;

  & > .header {
    height: 15%;
  }
  & > .main {
    height: 85%;
    width: 100%;
  }
`;
